import React, { Fragment, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import '../shared.css';

const PurchaseReturnDetails = () => {
    const { id } = useParams();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const { isAuthenticated, companyId, branchId, userId, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [formData, setFormData] = useState({});
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        fetchData('PurchaseReturnApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Purchase);
                    setInvoicedeatils(response.response_data.PurchaseDetails);
                }
            })
            .catch(err => console.error('Error fetching Purchase Return Details:', err));
    }, [id]);

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const d = new Date(dateString);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };

    return (
        <Fragment>
            <div className="pg-container">
                {/* ── Header ── */}
                <div className="pg-header">
                    <h5 className="pg-title">Purchase Return - Details</h5>
                    <div className="pg-header-actions">
                        <Link to="/PurchaseReturnIndex" className="pg-btn pg-btn-danger">
                            <CloseIcon /> Back to List
                        </Link>
                    </div>
                </div>

                {errorMessage && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
                {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

                <div className="pg-card">
                    {/* ── Row 1: GRN/CN + LR info ── */}
                    <div className="pg-hpanel">
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">GRN/CN Date</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="date"
                                value={formatDateForInput(formData.GRNDate)} disabled />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">GRN/CN Number</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.GRNNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">LR Date</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="date"
                                value={formatDateForInput(formData.LRDate)} disabled />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">LR Number</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.LRNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 100px' }}>
                            <span className="pg-hcell-label">Total Qty</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.TotalQuantity || ''} readOnly />
                        </div>
                    </div>

                    {/* ── Row 2: Remarks + Totals ── */}
                    <div className="pg-hpanel" style={{ marginTop: 8 }}>
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Remarks</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.Remarks || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Amount</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.Amount ? parseFloat(formData.Amount).toFixed(2) : '0.00'} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">GST Amount</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.GSTAmount ? parseFloat(formData.GSTAmount).toFixed(2) : '0.00'} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Total Amount</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.TotalAmount ? parseFloat(formData.TotalAmount).toFixed(2) : '0.00'} readOnly />
                        </div>
                    </div>

                    {/* ── Items Table ── */}
                    <div className="pg-invoice-table-wrap" style={{ marginTop: 12 }}>
                        <table className="pg-invoice-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Item Name</th>
                                    <th className="right">Quantity</th>
                                    <th className="right">Rate</th>
                                    <th className="right">Amount</th>
                                    <th className="right">GST</th>
                                    <th className="right">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoicedeatils.length === 0
                                    ? <tr><td colSpan={7} style={{ textAlign: 'center', color: '#94a3b8', padding: 14 }}>No items found.</td></tr>
                                    : invoicedeatils.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: 'center', width: 40 }}>{index + 1}</td>
                                            <td style={{ width: '35%' }}>{item.ItemName}</td>
                                            <td className="right">{item.Quantity}</td>
                                            <td className="right">{item.Rate != null ? parseFloat(item.Rate).toFixed(2) : '0.00'}</td>
                                            <td className="right">{item.Amount != null ? parseFloat(item.Amount).toFixed(2) : '0.00'}</td>
                                            <td className="right">{item.GSTAmount != null ? parseFloat(item.GSTAmount).toFixed(2) : '0.00'}</td>
                                            <td className="right" style={{ fontWeight: 700 }}>{item.TotalAmount != null ? parseFloat(item.TotalAmount).toFixed(2) : '0.00'}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
            </div>
        </Fragment>
    );
};

export default PurchaseReturnDetails;
